import { useMediaQuery, useTheme } from '@mui/material';

export const useResponsiveLimits = () => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.up('md'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.up('sm'));

  // Determine max items based on screen size
  const getMaxItems = () => {
    if (isLargeScreen) return 4; // 4 items + 1 "View More" = 5 items (can fit in 2 rows)
    if (isMediumScreen) return 3; // 3 items + 1 "View More" = 4 items (2x2 grid)
    return 2; // 2 items + 1 "View More" = 3 items
  };

  return {
    isLargeScreen,
    isMediumScreen,
    isSmallScreen,
    getMaxItems,
  };
};
